package di

import com.essntl.core.axus.di.axusModule
import com.essntl.core.gpt.di.gptModule
import com.essntl.core.network.networkModule
import com.essntl.core.quickbooks.di.QuickbooksClientImplModule
import com.essntl.core.settings.data.di.ConfigurationModule
import com.essntl.core.stripe.di.stripeModule
import com.essntl.core.supabase.supabaseModule
import com.essntl.core.twilio.di.twilioModule
import com.essntl.core.unsplash.di.unsplashModule
import com.essntl.core.utils.utils.loadingmanager.loadingManagerModule
import com.essntl.core.utils.utils.windowmanager.windowManagerModule
import com.essntl.core.waypoint.di.waypointModule
import com.essntl.core.whatsapp.data.di.whatsappModule
import com.essntl.features.address.data.di.AddressModule
import com.essntl.features.area.data.di.AreaModule
import com.essntl.features.area.domain.di.AddEditAreaUseCaseModule
import com.essntl.features.country.data.di.CountryModule
import com.essntl.features.authentication.data.di.AuthenticationModule
import com.essntl.features.category.data.di.CategoryModule
import com.essntl.features.category.domain.di.AddEditCategoryUseCaseModule
import com.essntl.features.client.data.di.ClientModule
import com.essntl.features.contact.data.di.ContactModule
import com.essntl.features.country.domain.di.AddEditCountryUseCaseModule
import com.essntl.features.crm.data.di.CRMModule
import com.essntl.features.currency.data.di.CurrencyModule
import com.essntl.features.file.data.di.FileModule
import com.essntl.features.invoice.data.InvoiceModule
import com.essntl.features.itinerary.data.di.ItineraryModule
import com.essntl.features.itinerary.domain.di.ItineraryServiceUseCaseModule
import com.essntl.features.message.data.di.MessageModule
import com.essntl.features.message.data.di.messageModule
import com.essntl.features.message.domain.di.MessageUseCaseModule
import com.essntl.features.notification.data.di.NotificationModule
import com.essntl.features.organization.data.di.OrganizationModule
import com.essntl.features.paymentlink.data.di.PaymentLinkModule
import com.essntl.features.paymentparameter.data.di.PaymentParameterModule
import com.essntl.features.price.data.di.PriceModule
import com.essntl.features.profile.data.di.ProfileModule
import com.essntl.features.proposal.data.di.ProposalModule
import com.essntl.features.proposal.domain.di.ProposalUseCaseModule
import com.essntl.features.qbauth.data.di.QbAuthModule
import com.essntl.features.request.data.di.RequestModule
import com.essntl.features.service.data.di.ServiceModule
import com.essntl.features.supplier.data.di.SupplierModule
import com.essntl.features.tag.data.di.TagModule
import com.essntl.features.task.data.di.TaskModule
import com.essntl.features.profile.domain.di.ProfileUseCaseModule
import com.essntl.features.service.domain.di.ExtraCategoryServiceUseCaseModule
import com.essntl.features.task.domain.di.TaskUseCaseModule
import com.essntl.features.travelagent.data.di.TravelAgentModule
import com.essntl.toastmanager.toastManagerModule
import core.datastore.di.datastoreModule
import core.dateformat.di.DateFormatUseCaseModule
import org.koin.ksp.generated.module

val commonModule
    get() =
        listOf(
            // Core modules
            networkModule,
            supabaseModule,
            unsplashModule,
            waypointModule,
            twilioModule,
            whatsappModule,
            axusModule,
            toastManagerModule,
            gptModule,
            stripeModule,
            loadingManagerModule,
            windowManagerModule,
            datastoreModule,
            QuickbooksClientImplModule().module,
            // Data modules
            CategoryModule().module,
            TagModule().module,
            ServiceModule().module,
            RequestModule().module,
            ProposalModule().module,
            FileModule().module,
            AreaModule().module,
            CountryModule().module,
            ItineraryModule().module,
            SupplierModule().module,
            ClientModule().module,
            TravelAgentModule().module,
            TaskModule().module,
            MessageModule().module,
            messageModule,
            PaymentLinkModule().module,
            PaymentParameterModule().module,
            QbAuthModule().module,
            InvoiceModule().module,
            ProfileModule().module,
            AuthenticationModule().module,
            NotificationModule().module,
            CurrencyModule().module,
            ConfigurationModule().module,
            CRMModule().module,
            ContactModule().module,
            OrganizationModule().module,
            AddressModule().module,
            PriceModule().module,

            // Use case modules
            ProposalUseCaseModule().module,
            TaskUseCaseModule().module,
            ProfileUseCaseModule().module,
            ExtraCategoryServiceUseCaseModule().module,
            ItineraryServiceUseCaseModule().module,
            MessageUseCaseModule().module,
            AddEditCountryUseCaseModule().module,
            AddEditAreaUseCaseModule().module,
            AddEditCategoryUseCaseModule().module,
            DateFormatUseCaseModule().module,
        )
